export interface Beneficiary {
  uniqueValue: string;
  firstName: string;
  lastName: string;
  oib: string;
  roleName: string;
  institutionName: string;
  InstitutionOIB: string;
  townName: string;
}


export const beneficiaryInitial: Beneficiary = {
  uniqueValue: "",
  firstName: "",
  lastName: "",
  oib: "",
  roleName: "",
  institutionName: "",
  InstitutionOIB: "",
  townName: "",
};



